import styled from '@emotion/styled';
import { Colors, Typography } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';

export const H2 = styled.h2`
  color: ${Colors.neutral800};
  ${Typography.pageHeader7};
`;

export const H3 = styled.h3`
  color: ${Colors.neutral800};
  ${Typography.subHeader1Bold};
`;

export const H4 = styled.h4`
  color: ${Colors.neutral800};
  ${Typography.subHeader1Semibold};
`;

export const H5 = styled.h5`
  color: ${Colors.neutral800};
  ${Typography.subHeader1Semibold};
`;

export const H6 = styled.h5`
  color: ${Colors.neutral800};
  ${Typography.subHeader1Semibold};
`;

export const P = styled.p`
  color: ${Colors.neutral700};
  ${Typography.paragraph3};
  a > * {
    font-size: 16px;
  }
  ${mediaQueries.tablet} {
    ${Typography.paragraph1};
    a > * {
      font-size: 18px;
    }
  }
`;

export const CalloutP = styled.p`
  color: ${Colors.neutral700};
  ${Typography.smallPrint1};
  ${mediaQueries.tablet} {
    ${Typography.paragraph3};
  }
`;

export const LI = styled.li`
  display: list-item;

  ::marker {
    color: #403f3e;
  }
`;

export const OL = styled.ol`
  color: ${Colors.neutral700};
  list-style: decimal;
  margin-left: 10px;
  padding-left: 27px;
  ${Typography.paragraph3};

  ${mediaQueries.tablet} {
    ${Typography.paragraph1};
  }
`;

export const UL = styled.ul`
  color: ${Colors.neutral700};
  list-style: disc;
  margin-left: 10px;
  padding-left: 10px;
  ${Typography.paragraph3};

  ${mediaQueries.tablet} {
    ${Typography.paragraph1};
  }
`;

export const QUOTE = styled.blockquote`
  font-style: italic;
  padding: 0 20px;
  margin-bottom: 30px;

  ${mediaQueries.tablet} {
    padding: 0 40px;
    margin-bottom: 40px;
  }
`;

export const BOLD = styled.strong``;

export const CODE = styled.code`
  color: #666;
  background-color: #f2f2f2;
  padding: 0.3em;
`;

export const ITALIC = styled.i``;

export const UNDERLINE = styled.u``;

export const TABLE = styled.table`
  margin-top: 0;
  margin-bottom: 16px;
  border-spacing: 0;
  border-collapse: collapse;
  display: block;
  max-width: 90vw; /* used instead of 100% for small devices */
  margin: 0 auto; /* central alignment */
  overflow: auto;
  border: 1px solid ${Colors.neutral400};
  border-radius: 5px;

  * {
    font-size: 16px;
  }

  td,
  th {
    padding: 0;
    text-align: left;
    padding: 7px 12px;
    border-right: 1px solid ${Colors.neutral400};
    p {
      line-height: 1.5;
    }
  }

  th * {
    font-weight: 600 !important;
  }

  tr,
  th {
    border-top: none;
  }

  thead,
  tbody {
    display: flex;
    flex-direction: column;
  }

  tr {
    display: flex;
    flex-direction: row;
  }

  tbody tr > td,
  thead tr > th {
    flex: 1 0 0;
    overflow-wrap: anywhere;
    min-width: 140px;
  }

  thead th:first-child,
  tbody td:first-child {
    border-left: none;
  }

  thead th:last-child,
  tbody td:last-child {
    border-right: none;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  tr td {
    background-color: ${Colors.neutral100};
    border-top: 1px solid hsla(210, 18%, 87%, 1);
  }

  tr:nth-child(2n) td {
    background-color: ${Colors.neutral200};
  }

  thead tr th {
    background-color: ${Colors.neutral200};
  }

  img {
    background-color: transparent;
  }
`;
